import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'more',
  templateUrl: './more.component.html',
  styleUrls: ['./more.component.css']
})
export class MoreComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
